export default __webpack_public_path__ + "src/assets/cdaiBreakdown.0fb3395be4d723e46b09247b18853d81.svg";